import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
import { MSEnum } from '@/commons/enumeration'
class WebSocketAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Notification";
  controllerName = 'Sockets';

  getRooms() {
    const request = { url: [this.getAPIUrl(), 'rooms'].join('/') };
    return httpClient.getAsync(request);
  }
}

export default new WebSocketAPI();
